import React from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import loginbg from "../../images/Icons/loginbg.jpg";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader";
import CheckAuth from "./CheckAuth";
import notificationService from "../../services/notificationService";

export default function Login() {
  const navigate = useNavigate();
  const isAuth = CheckAuth();
  useEffect(() => {
    if (isAuth) {
      navigate("/");
    }
  });
  const [data, setData] = useState({
    step: 1,
    phone: "",
    email: "",
    otp: "",
    otpTime: null,
  });
  const [loginMethod, setLoginMethod] = useState("phone");
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    phone: "",
    email: "",
    otp: "",
  });
  const vaildate = () => {
    const newError = {};
    switch (data.step) {
      case 1:
        if (loginMethod === "phone") {
          if (!data.phone || data.phone.length !== 10 || isNaN(data.phone)) {
            newError.phone = "Please enter a valid phone number";
          }
        } else if (loginMethod === "email") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!data.email || !emailRegex.test(data.email)) {
            newError.email = "Please enter a valid email address";
          }
        }
        break;

      case 2:
        if (!data.otp || isNaN(data.otp)) {
          newError.otp = "Please enter valid otp";
        }
        break;

      default:
        break;
    }

    setError(newError);
    return Object.keys(newError).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (vaildate()) {
      setLoading(true);
      switch (data.step) {
        case 1:
          try {
            const endpoint = loginMethod === "phone" ? "otp-login" : "email-otp";
            const payload = loginMethod === "phone" 
              ? { phone: data.phone }
              : { email: data.email };
              
            const response = await axios.post(
              `${config.apiUrl}/${endpoint}`,
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              }
            );
            const expireTime = Date.now() + 60 * 1000;
            setData((prevData) => ({
              ...prevData,
              step: 2,
              otpTime: expireTime,
            }));
            toast.success(response.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          } catch (error) {
            const errorMessage = error.response?.data?.message || "Something went wrong. Please try again.";
            if (loginMethod === "phone") {
              setError(prevData => ({
                ...prevData,
                phone: errorMessage,
              }));
            } else {
              setError(prevData => ({
                ...prevData,
                email: errorMessage,
              }));
            }
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          } finally {
            setLoading(false);
          }
          break;

        case 2:
          try {
            const endpoint = loginMethod === "phone" ? "verify-otp" : "verify-email-otp";
            const payload = loginMethod === "phone" 
              ? { phone: data.phone, otp: data.otp }
              : { email: data.email, otp: data.otp };
              
            const response = await axios.post(
              `${config.apiUrl}/${endpoint}`,
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              }
            );
            
            Cookies.set("bz_utkn", JSON.stringify(response.data.token), {
              expires: 7,
            });
            Cookies.set("bz_uinf", JSON.stringify(response.data.data), {
              expires: 7,
            });
            config.token =
              Cookies.get("bz_utkn") &&
              "Bearer " + JSON.parse(Cookies.get("bz_utkn"));
            config.user =
              Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));

            // Fetch seller profile if user is a seller to get permissions
            if (config.user.type === "seller") {
              try {
                const profileResponse = await axios.get(
                  `${config.apiUrl}/seller/profile`,
                  {
                    headers: {
                      Authorization: config.token,
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                  }
                );
                
                // Update user data with profile information including permissions
                const updatedUser = {
                  ...config.user,
                  is_staff: profileResponse.data.data.is_staff,
                  permission: profileResponse.data.data.permission
                };
                
                // Update cookies with new user data
                Cookies.set("bz_uinf", JSON.stringify(updatedUser), {
                  expires: 7,
                });
                config.user = updatedUser;
                
              } catch (profileError) {
                console.error('Error fetching seller profile:', profileError);
                // Continue with login process even if profile fetch fails
              }
            }

            // Initialize notifications after successful login
            try {
              await notificationService.initializeAfterLogin();
              console.log('Notifications initialized after login');
            } catch (notificationError) {
              console.error('Error initializing notifications after login:', notificationError);
              // Don't block login process if notifications fail
            }

            toast.success(response.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              if (config.user.type === "seller") {
                if(config.user.email === null){
                  navigate("/profile?edit=true");
                }else{
                  navigate("/commodity-products");
                }
              } else if (config.user.type === "customer" && config.user.email === null) {
                navigate("/profile?edit=true");
              } else {
                navigate("/");
              }
              resetData();
            }, 1500);
          } catch (error) {
            setError((prevData) => ({
              ...prevData,
              otp: error.response.data.message,
            }));
          } finally {
            setLoading(false);
          }
          break;

        default:
          break;
      }
    }
  };
  useEffect(() => {
    if (data.step === 2 && data.otpTime) {
      const updateTimer = () => {
        const timeLeft = Math.max(
          0,
          Math.floor((data.otpTime - Date.now()) / 1000)
        );
        setTimer(timeLeft);

        if (timeLeft <= 0) {
          resetData();
        }
      };
      updateTimer();
      const interval = setInterval(updateTimer, 1000);
      return () => clearInterval(interval);
    }
  }, [data.step, data.otpTime]);
  const resetData = () => {
    setData({
      step: 1,
      phone: "",
      email: "",
      otp: "",
      otpTime: null,
    });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="login-form">
          <div className="row">
            <div className="col-lg-5 col-md-5">
              <div className="login-left-bg">
                <img src={loginbg} alt="" />
              </div>
            </div>
            <div className="col-lg-7 col-md-7">
              {data.step === 1 && (
                <div className="login-form-box">
                  <h4>Welcome To Biznie</h4>
                  <p className="login-content">
                    To keep connected with us please login first
                  </p>
                  
                  {/* Login Method Selection */}
                  <div className="login-method-toggle mb-3">
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn ${loginMethod === "phone" ? "btn-danger" : "btn-outline-danger"}`}
                        onClick={() => {
                          setLoginMethod("phone");
                          setError({});
                          setData(prev => ({ ...prev, email: "" }));
                        }}
                      >
                        Mobile Number
                      </button>
                      <button
                        type="button"
                        className={`btn ${loginMethod === "email" ? "btn-danger" : "btn-outline-danger"}`}
                        onClick={() => {
                          setLoginMethod("email");
                          setError({});
                          setData(prev => ({ ...prev, phone: "" }));
                        }}
                      >
                        Email Address
                      </button>
                    </div>
                  </div>
                  
                  <form onSubmit={handleSubmit}>
                    {loginMethod === "phone" ? (
                      <div className="form-group">
                        <label htmlFor="phone">Mobile Number *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Enter Mobile Number"
                          value={data.phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setData((prevData) => ({
                                ...prevData,
                                phone: value,
                              }));
                            }
                          }}
                        />
                        {error.phone && (
                          <small className="input-error">{error.phone}</small>
                        )}
                      </div>
                    ) : (
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter Email Address"
                          value={data.email}
                          onChange={(e) => {
                            setData((prevData) => ({
                              ...prevData,
                              email: e.target.value,
                            }));
                          }}
                        />
                        {error.email && (
                          <small className="input-error">{error.email}</small>
                        )}
                      </div>
                    )}

                    <div className="form-footer">
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-danger w-100"
                      >
                        {loading ? <Loader /> : "Send OTP"}
                      </button>
                      <p>
                        By login, you agree to our{" "}
                        <Link to="/terms-and-conditions">
                          Terms & conditions
                        </Link>{" "}
                        and <Link to="/privacy-policy">Privacy Policy</Link>
                      </p>
                    </div>
                  </form>
                </div>
              )}

              {data.step === 2 && (
                <div className="login-form-box">
                  <h4>Verify your {loginMethod === "phone" ? "number" : "email"}</h4>
                  <p className="login-content">
                    Enter the OTP sent to your {loginMethod === "phone" ? "mobile number" : "email address"} {loginMethod === "phone" ? data.phone : data.email}
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="otp">OTP Verification *</label>
                      {/* <div className="otp-container">
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 0)" />
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 1)" />
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 2)" />
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 3)" />
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 4)" />
                        <input type="text" maxlength="1" className="otp-input" oninput="moveToNext(this, 5)" />
                      </div> */}
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        id="otp"
                        name="otp"
                        placeholder="Enter otp"
                        value={data.otp}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setData((prevData) => ({
                              ...prevData,
                              otp: value,
                            }));
                          }
                        }}
                      />
                      {error.otp && (
                        <small className="input-error">{error.otp}</small>
                      )}

                      {error.otp && (
                        <small className="input-error">{error.otp}</small>
                      )}
                    </div>
                    <div className="form-footer">
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-danger w-100"
                      >
                        {loading ? <Loader /> : "Submit"}
                      </button>

                      <p className="timer-pr">OTP will expire in {timer} sec</p>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
